import { register_university } from './constants';

export enum RegistrationWindowStatus {
  Upcoming = 'upcoming',
  Open = 'open',
  Closed = 'closed',
}

/**
 * Parses a date string in `DD/MM/YYYY` format (e.g. "23/08/2026") into a valid `Date`.
 * @param dateStr - Date string in `DD/MM/YYYY` format.
 */
export function parseDDMMYYYY(dateStr: string): Date {
  const [day, month, year] = (dateStr || '').trim().split('/').map(Number);
  return new Date(year, (month || 1) - 1, day || 1);
}

/**
 * Returns the ordinal suffix (st, nd, rd, th) for a given day of the month.
 */
export function getOrdinalSuffix(day: number): string {
  if (day % 10 === 1 && day % 100 !== 11) return 'st';
  if (day % 10 === 2 && day % 100 !== 12) return 'nd';
  if (day % 10 === 3 && day % 100 !== 13) return 'rd';
  return 'th';
}

/**
 * Formats a `Date` into a readable string, e.g. "23rd August 2026".
 */
export function formatDisplayDate(date: Date): string {
  const day = date.getDate();
  const month = date.toLocaleDateString('en-GB', { month: 'long' });
  const year = date.getFullYear();
  return `${day}${getOrdinalSuffix(day)} ${month} ${year}`;
}

/**
 * Method to determine whether the University Register Interest window is upcoming, open or closed
 * based on the `register_university` start and end dates.
 */
export function getRegistrationWindowStatus(
  now: Date = new Date(),
): RegistrationWindowStatus {
  const startDate = parseDDMMYYYY(register_university.start_date);
  const endDate = parseDDMMYYYY(register_university.end_date);
  endDate.setHours(23, 59, 59, 999);

  if (now < startDate) {
    return RegistrationWindowStatus.Upcoming;
  }

  if (now > endDate) {
    return RegistrationWindowStatus.Closed;
  }

  return RegistrationWindowStatus.Open;
}

/**
 * Method to get the user facing message for the current Register Interest window status.
 */
export function getRegistrationWindowMessage(
  status: RegistrationWindowStatus,
): string {
  const startDate = formatDisplayDate(
    parseDDMMYYYY(register_university.start_date),
  );
  const endDate = formatDisplayDate(
    parseDDMMYYYY(register_university.end_date),
  );

  switch (status) {
    case RegistrationWindowStatus.Upcoming:
      return `Registrations for the AIKosh University Engagement Programme will open on ${startDate}. Please check back then to submit your Register Interest form.`;
    case RegistrationWindowStatus.Closed:
      return `Form submission is closed. The Register Interest window for the AIKosh University Engagement Programme ended on ${endDate}.`;
    default:
      // return `Registrations for the AIKosh University Engagement Programme are open till ${endDate}. Register your interest before the window closes.`;
      return `Registrations for universities Engagement Programme open till ${endDate}. Register your interest before the window closes.`;

  }
}
